import { render, staticRenderFns } from "./sendlog.vue?vue&type=template&id=2aa17f43&scoped=true"
import script from "./sendlog.vue?vue&type=script&lang=js"
export * from "./sendlog.vue?vue&type=script&lang=js"
import style0 from "./sendlog.vue?vue&type=style&index=0&id=2aa17f43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa17f43",
  null
  
)

export default component.exports